import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import MdmRadio from '~/components/atoms/MdmRadio.vue';
import TextArea from '~/components/atoms/TextArea.vue';
import MdmIcon from '~/components/atoms/Global/MdmIcon';
var ELIGIBILITY_NULL = 0;
var IS_ELIGIBLE = 1;
var IS_NOT_ELIGIBLE = 2;
export default {
  name: 'FormReasons',
  components: {
    MdmRadio,
    TextArea,
    MdmIcon
  },
  props: {
    isReturnable: {
      type: Boolean,
      default: true
    },
    channel: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      form: {
        reserve: {
          value: null,
          error: null
        },
        comment: {
          value: '',
          error: null
        }
      },
      eligibility: ELIGIBILITY_NULL,
      notEligibleText: false
    };
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    language() {
      return this.locale.language;
    },

    reserveOptions() {
      return [{
        label: this.$t('radio.yes'),
        value: 'yes'
      }, {
        label: this.$t('radio.no'),
        value: 'no'
      }];
    },

    isMag() {
      return this.channel === 'mag';
    },

    isFormReasonsValid() {
      var reasons = Object.keys(this.form);
      return this.isProductReturnEligible() && reasons.every(field => {
        var {
          error
        } = this.form[field];
        if (error === null) return false;
        return !error;
      });
    }

  }),
  watch: {
    eligibility() {
      this.showErrorMsg();
    },

    /* If Bl has changed,
     * re calculate form configuration
     * (based on previously selected choices)
     */
    channel() {
      this.setFormConfiguration();
    }

  },
  methods: {
    isProductReturnEligible() {
      return this.eligibility === IS_ELIGIBLE;
    },

    showErrorMsg() {
      this.resetMsg();
      this.notEligibleText = this.eligibility === IS_NOT_ELIGIBLE;
    },

    setFormConfiguration() {
      this.eligibilityConfiguration();
    },

    eligibilityConfiguration() {
      this.eligibility = ELIGIBILITY_NULL;
      /* If Bl has changed,
       * calculate eligibility from previously selected reserve
       */

      if (this.form.reserve.value) {
        this.calculateEligibiltyOnReserve();
      }
    },

    resetMsg() {
      this.notEligibleText = false;
    },

    calculateEligibiltyOnReserve() {
      var isReserveChecked = this.form.reserve.value === 'yes';

      if (isReserveChecked) {
        this.eligibility = IS_ELIGIBLE;
      } else {
        this.checkDays();
      }
    },

    checkDays() {
      this.eligibility = this.isReturnable ? IS_ELIGIBLE : IS_NOT_ELIGIBLE;
    },

    validateField(key) {
      this.form[key].error = !this.form[key].value;
    },

    sendForm() {
      var form = {
        reserve: this.form.reserve.value,
        comment: this.form.comment.value
      };
      this.$emit('update-reasons', form);
    }

  }
};